import { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useAlert } from "react-alert";
import { exportToXlsx } from "../../../utility/exportPosRevenue";

import { PieChart, Pie, Cell } from "recharts";
import "./dashboard.scss";
import { useMediaQuery } from "react-responsive";

import { db } from "../../../firebase";

import itemSoldImg from "../../../images/itemSold.svg";
import totalRevenueImg from "../../../images/totalRevenue.svg";

import { ReactComponent as All } from "../../../images/All.svg";
import { ReactComponent as Beer } from "../../../images/Beers.svg";
import { ReactComponent as Softs } from "../../../images/Softs.svg";
import { ReactComponent as Food } from "../../../images/Fast-food.svg";
import { ReactComponent as HotDrinks } from "../../../images/hotDrinks.svg";
import { ReactComponent as Cocktails } from "../../../images/Cocktails.svg";
import { ReactComponent as Wine } from "../../../images/Wine.svg";
import { ReactComponent as Others } from "../../../images/Others.svg";
import { Icons } from "../../../images/icons";
import {
  BeersArray,
  CocktailsArray,
  FoodArray,
  HotDrinksArray,
  OtherArray,
  SoftsArray,
  WineArray,
  CategoriesArray,
} from "../../../utility/data";
import { Loader2 } from "../../../helper/loader";
import CategoryFilter from "../../../components/CategoryFilter/CategoryFilter";
import RevenueComparison from "./RevenueComparison";
import { periodBounds, validPeriod } from "../../../utility/posRevenueComparison";
import getRevenueSummary from "../../../utility/getRevenueSummary";
import getRevenueSummaryByDate from "../../../utility/getRevenueSummaryByDate";


function Dashboard({
  organizations,
  orgId,
  dateClickHandle,
  setDateRange,
  startDate,
  endDate,
  dateResetHandle,
  paymentMethod,
  comparisonEnabled = false,
  comparisonConfiguration,
  setComparisonConfiguration,
}) {
  const navigate = useNavigate();
  const alert = useAlert();
  const { t } = useTranslation("dashboard");

  const [customCategories, setCustomCategories] = useState([]);
  const [productData, setProductData] = useState([]);
  const [productDataInitial, setproductDataInitial] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [itemSold, setItemSold] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [softRevenue, setsoftRevenue] = useState(0);
  const [hotDrinkRevenue, setHotDrinkRevenue] = useState(0);
  const [beerRevenue, setBeerRevenue] = useState(0);
  const [cocktailRevenue, setCocktailRevenue] = useState(0);
  const [foodRevenue, setFoodRevenue] = useState(0);
  const [wineRevenue, setWineRevenue] = useState(0);
  const [otherRevenue, setOtherRevenue] = useState(0);
  const [loader, setLoader] = useState(false);
  const [liquiditySelected, setLiquiditySelected] = useState({});

  const [filter, setFilter] = useState("All");
  const requestNumber = useRef(0);
  const [loadedPeriod, setLoadedPeriod] = useState(null);
  const [fetchError, setFetchError] = useState(false);
  const orgKey = [...new Set(orgId || [])].sort().join(",");

  const [show, setShow] = useState(false);
  const [reloading, setReloading] = useState(false);
  const currentOrgId = orgId?.[0];

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getOrgCategories = async () => {
    if (!currentOrgId) {
      return [];
    }

    let records = [];
    const q = query(collection(db, "Categories"), where("orgId", "==", currentOrgId));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      records.push(doc.data());
    });
    return records;
  };

  // File: src/pages/dashboardPages/dashboard/dashboard.jsx
  const computeFromSummary = (summaryData) => {
    let findQantity = 0;
    let findSoftQuantity = 0;
    let findBeerQuantity = 0;
    let findCocktailQuantity = 0;
    let findFoodQuantity = 0;
    let findWineQuantity = 0;
    let findHotDrinksQuantity = 0;
    let findOtherQuantity = 0;
    let findRevenue = 0;


    const elements = (Array.isArray(summaryData) ? summaryData : [summaryData]).filter(Boolean);
    elements.forEach((element) => {
      const products = Array.isArray(element.products) ? element.products : [];
      products.forEach((product) => {
        findQantity += Number(product.quantity) || 0;

        switch (product.category) {
          case "Softs":
            findSoftQuantity += Number(product.totalDue) || 0;
            break;
          case "Beers":
            findBeerQuantity += Number(product.totalDue) || 0;
            break;
          case "Cocktails":
            findCocktailQuantity += Number(product.totalDue) || 0;
            break;
          case "Food":
            findFoodQuantity += Number(product.totalDue) || 0;
            break;
          case "Wine":
            findWineQuantity += Number(product.totalDue) || 0;
            break;
          case "Hot drinks":
            findHotDrinksQuantity += Number(product.totalDue) || 0;
            break;
          case "Other":
            findOtherQuantity += Number(product.totalDue) || 0;
            break;
          default:
            // If category is unknown, count it as Other
            findOtherQuantity += Number(product.totalDue) || 0;
            break;
        }
      });

      switch (paymentMethod) {
        case "card":
          findRevenue += Number(element.cardAmount) || 0;
          break;
        case "cash":
          findRevenue += Number(element.cashAmount) || 0;
          break;
        case "qr":
          findRevenue += Number(element.qrAmount) || 0;
          break;
        case "bankTransfer":
          findRevenue += Number(element.bankTransferAmount) || 0;
          break;
        case "cashless":
          findRevenue += Number(element.cashlessAmount) || 0;
          break;
        default:
          findRevenue +=
            (Number(element.cardAmount) || 0) +
            (Number(element.cashAmount) || 0) +
            (Number(element.qrAmount) || 0) +
            (Number(element.bankTransferAmount) || 0);
      }
    });

    // revenue for graph
    setsoftRevenue(findSoftQuantity);
    setBeerRevenue(findBeerQuantity);
    setCocktailRevenue(findCocktailQuantity);
    setFoodRevenue(findFoodQuantity);
    setWineRevenue(findWineQuantity);
    setHotDrinkRevenue(findHotDrinksQuantity);
    setOtherRevenue(findOtherQuantity);
    // revenue for graph

    setTotalRevenue(findRevenue);
    setItemSold(findQantity);
  };

  const tableFilter = () => {
    const normalized = filter.toLowerCase();
    const initial = productDataInitial || [];
    const data =
      normalized === "all"
        ? initial
        : initial.filter((p) => p.category?.toLowerCase() === normalized);

    // Ensure duplicates are removed whenever the filter changes
    const uniqueData = Array.from(
      new Map(data.map((p) => [`${p.title}-${p.category}-${p.price}`, p])).values(),
    );

    setProductData(uniqueData);
  };

  useEffect(() => {
    tableFilter();
  }, [filter, productDataInitial]);

  const requestContext = useRef(null);
  requestContext.current = { orgId, startDate, endDate, paymentMethod, computeFromSummary, getOrgCategories };

  useEffect(() => {
    const { orgId: selectedOrgIds, startDate: fromDate, endDate: toDate, paymentMethod: method,
      computeFromSummary: compute, getOrgCategories: loadCategories } = requestContext.current;
    const number = ++requestNumber.current;
    const controller = new AbortController();
    if (comparisonEnabled) return () => controller.abort();
    setOrderData([]);
    setCustomCategories([]);
    setProductData([]);
    setproductDataInitial([]);
    setLoadedPeriod(null);
    setFetchError(false);
    compute({});
    if (!selectedOrgIds?.length || !validPeriod([fromDate, toDate])) {
      setLoader(false);
      return () => controller.abort();
    }
    loadCategories().then((categories) => {
      if (!controller.signal.aborted && number === requestNumber.current) setCustomCategories(categories);
    }).catch(() => {
      if (!controller.signal.aborted && number === requestNumber.current) setCustomCategories([]);
    });
    setLoader(true);
    setFetchError(false);
    const period = [new Date(fromDate), new Date(toDate)];
    const [start, end] = periodBounds(period);
    getRevenueSummary(selectedOrgIds, start, end, { paymentMethod: method || "all", includeOrganizations: true, signal: controller.signal })
      .then((summary) => {
        if (controller.signal.aborted || number !== requestNumber.current) return;
        const safe = { ...summary, products: Array.isArray(summary?.products) ? summary.products : [] };
        setOrderData([safe]);
        setproductDataInitial(safe.products);
        compute(safe);
        setLoadedPeriod(period);
      }).catch((error) => {
        if (!controller.signal.aborted && number === requestNumber.current) setFetchError(true);
      }).finally(() => {
        if (!controller.signal.aborted && number === requestNumber.current) setLoader(false);
      });
    return () => controller.abort();
  }, [orgKey, dateClickHandle, dateResetHandle, reloading, paymentMethod, comparisonEnabled]);

  const handleClickLiquidity = (item) => {
    setLiquiditySelected(item);
    handleShow();
  };

  const submitEditLiquidity = () => {
    setLoader(true);
    if (liquiditySelected?.maxLiquidity && liquiditySelected?.liquidity) {
      const postListRef = doc(db, "Organizations", liquiditySelected?.id);
      updateDoc(postListRef, {
        maxLiquidity: liquiditySelected?.maxLiquidity,
        liquidity: liquiditySelected?.liquidity,
      })
        .then((res) => {
          handleClose();
          setLiquiditySelected({});
          setLoader(false);
          for (let i = 0; i < organizations.length; i++) {
            if (organizations[i].id === liquiditySelected?.id) {
              organizations[i].liquidityAmount = liquiditySelected?.liquidityAmount;
              organizations[i].liquidity = liquiditySelected?.liquidity;
            }
          }
          alert.show(t("liquidity_updated"), { type: "success" });
        })
        .catch((err) => {
          console.error(err);
          alert.show(t("something_went_wrong"), { type: "error" });
          setLoader(false);
        });
    } else {
      alert.show(t("please_fill_all_fields"), { type: "error" });
      setLoader(false);
    }
  };

  return (
    <>
      <div className="container-fluid dashboard">
        <RevenueComparison enabled={comparisonEnabled} organizations={organizations} orgId={orgId}
          startDate={startDate} endDate={endDate} setDateRange={setDateRange}
          paymentMethod={paymentMethod} resetToken={dateResetHandle}
          configuration={comparisonConfiguration} setConfiguration={setComparisonConfiguration} />
        <div hidden={comparisonEnabled}>
        {fetchError && <div role="alert"><p>{t("comparison_load_failed")}</p>
          <button className="themeBtn themeBtnSecondary" onClick={() => setReloading((value) => !value)}>{t("comparison_retry")}</button></div>}
        {loader && (
          <div className="dashboardInlineLoader" role="status" aria-live="polite">
            <Loader2 />
          </div>
        )}
        <div className="row mx-0">
          <div className="col-xxl-9 col-xl-9">
            <div className="row row1">
              <div className="col-12 col-md-5 order-2 order-md-1 d-flex flex-md-column mt-3 mt-md-0 gap-3">
                <div className="themeCard itemCard">
                  <div className="itemImg">
                    <img className="img-fluid" src={itemSoldImg} alt="" />
                  </div>
                  <div className="content">
                    <h3>{itemSold}</h3>
                    <p>{t("products_sold")}</p>
                  </div>
                </div>
                <div className="themeCard itemCard">
                  <div className="itemImg">
                    <img className="img-fluid" src={totalRevenueImg} alt="" />
                  </div>
                  <div className="content">
                    <h3>{totalRevenue > 0 ? totalRevenue.toFixed(2) : totalRevenue} €</h3>
                    <p>{t("total_revenue")}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-7 order-1 order-md-2">
                <div className="themeCard col2">
                  <h3>{t("progress")}</h3>
                  <div className="chartRow">
                    <div className="chartMain">
                      <RevenueChart
                        softRevenue={softRevenue}
                        beerRevenue={beerRevenue}
                        cocktailRevenue={cocktailRevenue}
                        hotDrinkRevenue={hotDrinkRevenue}
                        foodRevenue={foodRevenue}
                        wineRevenue={wineRevenue}
                        otherRevenue={otherRevenue}
                      />
                    </div>
                    <div className="content">
                      <div className="colorRow">
                        <div className="circle blue"></div>
                        {beerRevenue ? ((beerRevenue / totalRevenue) * 100).toFixed(2) : 0} %{" "}
                        {t("beers")}
                      </div>
                      <div className="colorRow">
                        <div className="circle pink"></div>
                        {softRevenue ? ((softRevenue / totalRevenue) * 100).toFixed(2) : 0} %{" "}
                        {t("softs")}
                      </div>
                      <div className="colorRow">
                        <div className="circle green"></div>
                        {foodRevenue ? ((foodRevenue / totalRevenue) * 100).toFixed(2) : 0} %{" "}
                        {t("food")}
                      </div>
                      <div className="colorRow">
                        <div className="circle yellow"></div>
                        {cocktailRevenue
                          ? ((cocktailRevenue / totalRevenue) * 100).toFixed(2)
                          : 0}{" "}
                        % {t("cocktails")}
                      </div>
                      <div className="colorRow">
                        <div className="circle orange"></div>
                        {wineRevenue ? ((wineRevenue / totalRevenue) * 100).toFixed(2) : 0} %{" "}
                        {t("wine")}
                      </div>
                      <div className="colorRow">
                        <div className="circle red"></div>
                        {hotDrinkRevenue
                          ? ((hotDrinkRevenue / totalRevenue) * 100).toFixed(2)
                          : 0}{" "}
                        % {t("hot_drinks")}
                      </div>
                      <div className="colorRow">
                        <div className="circle purple"></div>
                        {otherRevenue ? ((otherRevenue / totalRevenue) * 100).toFixed(2) : 0} %{" "}
                        {t("others")}
                      </div>
                      <div className="total dn-sm">
                        {t("total_revenue")}:{" "}
                        {totalRevenue > 0 ? totalRevenue.toFixed(2) : totalRevenue}€
                      </div>
                    </div>
                  </div>
                  <div className="total dn-lg ">
                    {t("total_revenue")}: €{" "}
                    {totalRevenue > 0 ? totalRevenue.toFixed(2) : totalRevenue}
                  </div>
                </div>
              </div>
            </div>

            <Table
              productData={productData}
              customCategories={customCategories}
              orderData={orderData}
              totalRevenue={totalRevenue}
              setFilter={setFilter}
              filter={filter}
              startDate={loadedPeriod?.[0]}
              endDate={loadedPeriod?.[1]}
              paymentMethod={paymentMethod}
              organizations={organizations}
              orgId={orgId}
              setLoader={setLoader}
              loader={loader}
            />
          </div>
          <div className="col-xxl-3 col-xl-3">
            <div className="amountMainCard themeCard">
              <h4>{t("liquidity_per_cash_register")}</h4>
              {organizations
                .filter((item) => orgId.includes(item?.id))
                .map((item) => (
                  <div
                    key={item.id}
                    className={
                      parseFloat(item?.liquidity) - parseFloat(item?.maxLiquidity) < 1000 &&
                      parseFloat(item?.liquidity) > parseFloat(item?.maxLiquidity)
                        ? "priceMain card2"
                        : parseFloat(item?.liquidity) - parseFloat(item?.maxLiquidity) >= 1000 &&
                            parseFloat(item?.liquidity) > parseFloat(item?.maxLiquidity)
                          ? "priceMain card3"
                          : "priceMain card1"
                    }
                    onClick={() => handleClickLiquidity(item)}
                  >
                    <div className="liquididate">{item?.organization}</div>
                    <div className="liquidity">
                      {item?.liquidity ? parseFloat(item?.liquidity).toFixed(2) : 0} €
                    </div>
                    <div className="liquididate">{t("total_liquidity")}</div>
                    <div className="max">
                      {t("max_liquidity")}:{" "}
                      {item?.maxLiquidity ? parseFloat(item?.maxLiquidity).toFixed(2) : 0} €
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("update_liquidity")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="liquidityEditForm">
            <div className="mb-3">
              <label>{t("max_liquidity")}</label>
              <input
                name="maxLiquidity"
                value={liquiditySelected?.maxLiquidity}
                onChange={(e) =>
                  setLiquiditySelected({
                    ...liquiditySelected,
                    [e.target.name]: e.target.value,
                  })
                }
                className="form-control"
                placeholder={t("max_liquidity")}
                type="text"
              />
            </div>
            <div className="mb-3">
              <label>{t("liquidity")}</label>
              <input
                name="liquidity"
                value={liquiditySelected?.liquidity}
                onChange={(e) =>
                  setLiquiditySelected({
                    ...liquiditySelected,
                    [e.target.name]: e.target.value,
                  })
                }
                className="form-control"
                placeholder={t("liquidity")}
                type="text"
              />
            </div>
            <button className="themeBtn w-100 mt-4" onClick={submitEditLiquidity}>
              {t("update")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const Table = ({
  productData,
  customCategories,
  orderData,
  totalRevenue,
  filter,
  setFilter,
  startDate,
  endDate,
  organizations = [],
  orgId = [],
  paymentMethod = "",
  setLoader,
  loader,
}) => {
  const { t } = useTranslation("dashboard");
  const alert = useAlert();
  const [showExportModal, setShowExportModal] = useState(false);
  const [separateByDate, setSeparateByDate] = useState(false);
  const handleExportClose = () => setShowExportModal(false);
  const handleExportShow = () => setShowExportModal(true);

  const summaryMap = useMemo(() => {
    const map = {};
    if (orderData && orderData[0]) {
      (orderData[0].products || []).forEach((p) => {
        const key = `${p.title}-${p.category}-${p.price}`;

        if (!map[key]) {
          map[key] = { ...p };
        } else {
          map[key].quantity = (map[key].quantity || 0) + (p.quantity || 0);
          map[key].totalDue = (map[key].totalDue || 0) + (p.totalDue || 0);
          map[key].quantityIn = (map[key].quantityIn || 0) + (p.quantityIn || 0);
          map[key].totalIn = (map[key].totalIn || 0) + (p.totalIn || 0);
          map[key].quantityOut = (map[key].quantityOut || 0) + (p.quantityOut || 0);
          map[key].totalOut = (map[key].totalOut || 0) + (p.totalOut || 0);
        }
      });
    }
    return map;
  }, [orderData]);

  const handleExport = async () => {
    if (orderData && orderData[0]) {
      setLoader(true);
      try {
        const [startTs, endTs] = periodBounds([startDate, endDate]);

        const selectedOrgs = (organizations || []).filter((org) => orgId.includes(org.id));

        const mainSummary = separateByDate
          ? await getRevenueSummaryByDate(orgId, startTs, endTs, {
              paymentMethod: paymentMethod || "all", includeOrganizations: true,
            })
          : orderData[0];
        const perOrgSummaries = selectedOrgs.map((org) => {
          const summary = mainSummary.byOrganization?.[org.id];
          if (!summary) throw new Error("Missing organization revenue summary");
          return { ...org, ...summary };
        });

        exportToXlsx(mainSummary, startDate, endDate, perOrgSummaries, separateByDate, paymentMethod || "all", t);
      } catch (error) {
        alert.show(t("export_summary.error"), { type: "error" });
      } finally {
        setLoader(false);
      }
    }
  };

  return (
    <>
      <div className="card themeCard themeTable br-10 border-transparent ">
        <div className="card-header bg-white border-transparent pt-3 d-flex justify-content-between align-items-center">
          <h6 className="m-0 tableHeading">{t("products_sold")}</h6>
          <button
            className="themeBtn themeBtnSecondary py-1 min-h-40 m-0 text-capitalize min-w-131px"
            type="button"
            onClick={handleExportShow}
            disabled={loader || !startDate || !endDate || !orderData[0]}
          >
            {t("export")}
          </button>
        </div>

        <CategoryFilter
          filters={[
            { id: "All", label: t("all"), icon: All },
            { id: "Beers", label: t("beers"), icon: Beer },
            { id: "Softs", label: t("softs"), icon: Softs },
            { id: "Food", label: t("food"), icon: Food },
            { id: "Cocktails", label: t("cocktails"), icon: Cocktails },
            { id: "Wine", label: t("wine"), icon: Wine },
            { id: "Hot drinks", label: t("hot_drinks"), icon: HotDrinks },
            { id: "Other", label: t("others"), icon: Others },
            ...customCategories.map((cat) => ({
              id: cat.title,
              label: cat.title,
              iconSrc: CategoriesArray.find((i) => i.name === cat.customIcon)?.icon,
            })),
          ]}
          activeFilter={filter}
          onFilterChange={setFilter}
        />
        <div className="card-header br-10 table-responsive bg-white border-transparent py-3 d-flex flex-row align-items-center justify-content-between">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">{t("product")}</th>
                <th scope="col">{t("number_sold")}</th>
                <th scope="col">{t("price")}</th>
                <th scope="col">{t("vat")}</th>
                <th scope="col">{t("total_percentage")}</th>
                <th scope="col">{t("revenue")}</th>
                <th scope="col">{t("xvat_revenue")}</th>
              </tr>
            </thead>
            <tbody>
              {productData.map((val) => (
                <TableRow
                  key={`${val.id}-${val.title}-${val.category}-${val.price}`}
                  val={val}
                  summary={summaryMap[`${val.title}-${val.category}-${val.price}`]}
                  totalRevenue={totalRevenue}
                />
              ))}
              {productData.length === 0 && (
                <tr>
                  <td colSpan={7}>
                    <h4 className="text-center">{t("no_data")}</h4>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal show={showExportModal} onHide={handleExportClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("export")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Check
            type="checkbox"
            id="separateByDate"
            label={t("separate_products_by_date", "Separate revenue per product per date")}
            checked={separateByDate}
            onChange={(e) => setSeparateByDate(e.target.checked)}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="themeBtn themeBtnSecondary" onClick={handleExportClose}>
            {t("cancel", "Cancel")}
          </button>
          <button
            className="themeBtn"
            disabled={loader}
            onClick={() => {
              handleExport();
              handleExportClose();
            }}
          >
            {t("export")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

function TableRow({ val, summary = {}, totalRevenue }) {
  const prodQuantity = summary.quantity || 0;
  const prodRevenue = summary.totalDue || 0;
  const vatValue = val?.vat ?? val?.vatRate ?? summary.vat ?? "N/A";
  const categoryDefaultIcons = {
    Food: Icons.food,
    Softs: Icons.soft,
    Beers: Icons.beer,
    Cocktails: Icons.cocktail,
    "Hot drinks": Icons.drink,
    Wine: Icons.wine || Icons.cocktail,
    Other: Icons.others,
  };

  const resolveCustomIcon = () => {
    if (!val?.customIcon) {
      return null;
    }

    const categoryArrayMap = {
      Food: FoodArray,
      Softs: SoftsArray,
      Beers: BeersArray,
      Cocktails: CocktailsArray,
      Wine: WineArray,
      "Hot drinks": HotDrinksArray,
      Other: OtherArray,
    };

    const categoryIcons = categoryArrayMap[val.category] || CategoriesArray;
    const foundIcon = categoryIcons.find((item) => item.name === val.customIcon)?.icon;

    if (foundIcon) {
      return foundIcon;
    }

    return CategoriesArray.find((item) => item.name === val.customIcon)?.icon || null;
  };

  const productIcon =
    val?.title === "Cashless activation cost"
      ? Icons.cashless
      : resolveCustomIcon() || categoryDefaultIcons[val?.category] || Icons.others;

  const adjustedRevenue = () => {
    const vatNum = typeof vatValue === "number" ? vatValue : 0;
    return prodRevenue / (1 + vatNum / 100);
  };

  return (
    <tr>
      <td scope="row">
        <div className="profileDiv">
          <div className="imgDiv">
            <img
              src={productIcon}
              alt=""
              onError={(event) => {
                event.currentTarget.onerror = null;
                event.currentTarget.src = Icons.others;
              }}
            />
          </div>
          <div className="name">{val?.title}</div>
        </div>
      </td>
      <td>{prodQuantity} Pcs</td>
      <td>{val?.price} €</td>
      <td>{typeof vatValue === "number" ? vatValue : "N/A"}%</td>
      <td>{totalRevenue ? ((prodRevenue / totalRevenue) * 100).toFixed(2) : 0} %</td>
      <td>
        <div className={prodRevenue >= 0 ? "price" : "refund"}>{prodRevenue.toFixed(2)} €</div>
      </td>
      <td>
        <div>{adjustedRevenue().toFixed(2)} €</div>
      </td>
    </tr>
  );
}

function RevenueChart({
  softRevenue,
  beerRevenue,
  cocktailRevenue,
  hotDrinkRevenue,
  foodRevenue,
  wineRevenue,
  otherRevenue,
}) {
  const isBigScreen = useMediaQuery({ query: "(min-width: 576px)" });
  const [height, setHeight] = useState(170);
  const [width, setWidth] = useState(170);
  const [cx, setCx] = useState(80);
  const [cy, setCy] = useState(80);
  const [innerRadius, setInnerRadius] = useState(50);
  const [outerRadius, setOuterRadius] = useState(70);

  const data = [
    { name: "Group A", value: beerRevenue || 10 },
    { name: "Group B", value: softRevenue || 10 },
    { name: "Group C", value: foodRevenue || 10 },
    { name: "Group D", value: cocktailRevenue || 10 },
    { name: "Group E", value: wineRevenue || 10 },
    { name: "Group F", value: hotDrinkRevenue || 10 },
    { name: "Group G", value: otherRevenue || 10 },
  ];
  const COLORS = ["#025ef3", "#F302CA", "#00af00", "#F2C94C", "#ffa500", "#ea0000", "#7600EF"];

  return (
    // <ResponsiveContainer width="100%" height="100%">
    <PieChart width={width} height={height} onMouseEnter={""}>
      <Pie
        data={data}
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        fill="#8884d8"
        paddingAngle={5}
        dataKey="value"
      >
        {data.map((key, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>
    </PieChart>
    //  </ResponsiveContainer>
  );
}

export { Dashboard };
